import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../../../Redux";

const InventoryGeneralSettings = (params) => {
  const dispatch = useDispatch();
  const InventoryGeneralSettingData = useSelector(
    (state) => state?.settingReducer?.inventory_general_settings_data
  );
  const [postData, setPostData] = useState({
    inventory_management_type: "",
    expected_inventory_calculation: "",
    production_sheet: "",
    pre_populate: "",
    margin_of_error: "",
  });

  useEffect(() => {
    dispatch(actions.getInventoryGeneralSettingsData());
  }, []);

  useEffect(() => {
    console.log("InventoryGeneralSettingData", InventoryGeneralSettingData);
    setPostData({
      ...postData,
      inventory_management_type:
        InventoryGeneralSettingData?.inventory_general_setting
          ?.inventory_management_type,
      expected_inventory_calculation:
        InventoryGeneralSettingData?.inventory_general_setting
          ?.expected_inventory_calculation,
      production_sheet:
        InventoryGeneralSettingData?.inventory_general_setting
          ?.production_sheet,
      margin_of_error:
        InventoryGeneralSettingData?.inventory_general_setting?.margin_of_error,
      pre_populate:
        InventoryGeneralSettingData?.inventory_general_setting?.pre_populate,
    });
  }, [InventoryGeneralSettingData]);

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="row employeeSettingSec d-flex">
              <div className="col-md-12">
                <div className="shadowclass d-flex flex-wrap align-content-start">
                  <h4 className="event-alert w-100">
                    Inventory Management Type
                  </h4>
                  <div className="d-flex w-100 pt-0">
                    <ul class="mgt-type col-12">
                      <li>
                        <div class="col-set">
                          <div class="none-sec">
                            <h4>None</h4>
                            <article>
                              <p>
                                By selecting this box, this account will
                                effectively remove all Count functionality in
                                the Inventory Management module.
                              </p>
                              <h5>Pros</h5>
                              <div class="listing">
                                <p> No effort required.</p>
                                <p>
                                  {" "}
                                  The system encourages its customers to move
                                  toward Best Practice Inventory Management, so
                                  the Inventory Management Type can always be
                                  upgraded to either Physical Only or Perpetual
                                  and Physical
                                </p>
                                <h5>Cons</h5>
                                <p>
                                  {" "}
                                  No visibility and control around what is
                                  happening with inventory assets.
                                </p>
                                <p>
                                  {" "}
                                  Lack of tangible basis for variance checks
                                  including portioning or theft audits.
                                </p>
                                <p>
                                  {" "}
                                  Less accurate supply cost estimates as the
                                  system will have to use the supply expenses
                                  incurred during a given period as the total
                                  supply cost rather than the actual amount
                                  used.
                                </p>
                              </div>
                            </article>
                          </div>
                          <div class="radio-cust">
                            <input
                              type="hidden"
                              name="data[InventoryGeneralSetting][id]"
                              value="268"
                              id="InventoryGeneralSettingId"
                            />{" "}
                            <input
                              type="radio"
                              id="InventoryGeneralSettingInventoryManagementType0"
                              value="0"
                              checked={
                                postData.inventory_management_type === 0
                                  ? true
                                  : false
                              }
                            />
                            <label
                              className="pointer-none"
                              onClick={() =>
                                setPostData({
                                  ...postData,
                                  inventory_management_type: 0,
                                })
                              }
                              for="InventoryGeneralSettingInventoryManagementType0"
                            >
                              0
                            </label>{" "}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="col-set">
                          <div class="none-sec">
                            <h4>Physical Only</h4>
                            <article>
                              <p>
                                This will allow access to the system’s flexible
                                and efficient Count functionality and screens.
                                With the Count functionality, there is a choice
                                to either use the provided template Counts
                                (including various frequencies and inventory
                                item categories) and/or create new Counts that
                                fit any business model. This should be
                                considered the bare minimum of a well-run
                                F&amp;B establishment when it comes to Inventory
                                Management.
                              </p>
                              <h5>Pros</h5>
                              <div class="listing">
                                <p>
                                  {" "}
                                  Low-to-Medium level of effort is required
                                  (depending on frequency)
                                </p>
                                <p>
                                  {" "}
                                  Increased transparency and control on
                                  inventory assets – incrementally increases
                                  with greater frequency.
                                </p>
                                <p>
                                  {" "}
                                  Provides a tangible basis for variance checks
                                  (if the “Sales- Based Estimate“ Expected
                                  Inventory Calculation setting is also
                                  selected).
                                </p>
                                <p>
                                  {" "}
                                  If performed at least monthly, it enables the
                                  system to have a much more robust and accurate
                                  supply cost estimation for the Finance Module.
                                </p>
                                <p>
                                  {" "}
                                  The system encourages its customers to move
                                  toward Best Practice Inventory Management, so
                                  the Inventory Management Type can always be
                                  upgraded to Perpetual and Physical
                                </p>
                              </div>
                              <h5>Cons</h5>
                              <div class="listing">
                                <p>
                                  {" "}
                                  More effort than choosing to forego Inventory
                                  Management
                                </p>
                                <p>
                                  {" "}
                                  No “actual“ basis for comparison variance
                                  checks available as, best case, this type of
                                  Inventory Management relies on Sales figures
                                  to estimate expected stock levels for
                                  comparison against the stock count (see Cons
                                  with Sales-Based Estimate).
                                </p>
                                <p>
                                  {" "}
                                  Requires commitment as the system will not
                                  allow going back to None in the interest of
                                  protecting historical records and
                                  calculations.
                                </p>
                              </div>
                            </article>
                          </div>
                          <div
                            onClick={() =>
                              setPostData({
                                ...postData,
                                inventory_management_type: 1,
                              })
                            }
                            class="radio-cust pointer-none"
                          >
                            <input
                              type="radio"
                              id="InventoryGeneralSettingInventoryManagementType1"
                              value="1"
                              disabled
                              checked={
                                postData.inventory_management_type === 1
                                  ? true
                                  : false
                              }
                            />
                            <label for="InventoryGeneralSettingInventoryManagementType1">
                              1
                            </label>{" "}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="col-set">
                          <div class="none-sec">
                            <h4>Perpetual and Physical</h4>
                            <article>
                              <p>
                                This will enable the Check-in/Check-out
                                functionality as well as the Count functionality
                                (in the case where user switched from Inventory
                                Management Type None, otherwise just the
                                Check-in/Check-Out functionality). Having both
                                of these functionalities and processes running
                                in parallel will enable best practice F&amp;B
                                Inventory Management and is the RECOMMENDED
                                option.
                              </p>
                              <h5>Pros</h5>
                              <div class="listing">
                                <p>
                                  {" "}
                                  Real-time tracking of inventory allows for
                                  highest level of transparency and control over
                                  inventory assets.
                                </p>
                                <p>
                                  {" "}
                                  Improves responsiveness and accuracy for the
                                  order management process.
                                </p>
                                <p>
                                  {" "}
                                  Enables system to switch to be production
                                  process-focused by allowing ability to closely
                                  track the lifecycle from raw ingredient, to
                                  recipe, and eventually to menu item
                                </p>
                                <p>
                                  {" "}
                                  Provides greater level of explanatory power
                                  when analyzing variances between the latest
                                  count and the expected inventory levels
                                </p>
                              </div>
                              <h5>Cons</h5>
                              <div class="listing">
                                <p>
                                  {" "}
                                  High level of effort required by storage
                                  manager to track all incoming and outgoing
                                  inventory from storage areas.
                                </p>
                              </div>
                            </article>
                          </div>
                          <div
                            onClick={() =>
                              setPostData({
                                ...postData,
                                inventory_management_type: 2,
                              })
                            }
                            class="radio-cust"
                          >
                            <input
                              type="radio"
                              id="InventoryGeneralSettingInventoryManagementType2"
                              value="2"
                              checked={
                                postData.inventory_management_type === 2
                                  ? true
                                  : false
                              }
                            />
                            <label for="InventoryGeneralSettingInventoryManagementType2">
                              2
                            </label>{" "}
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="row employeeSettingSec d-flex">
              <div className="col-md-12">
                <div className="shadowclass d-flex flex-wrap align-content-start">
                  <h4 className="event-alert w-100">
                    Expected Inventory Calculation
                  </h4>
                  <div className="d-flex w-100 pt-0">
                    <ul class="mgt-type col-12">
                      <li>
                        <div class="col-set">
                          <div class="none-sec">
                            <h4>None</h4>
                            <article>
                              <p>
                                When this selection is made, it indicates the
                                preference to not perform any Expected Inventory
                                calculation for the purposes of variance
                                analysis or to populate any Expected Inventory
                                fields in the Inventory module.
                              </p>
                              <h5>Pros</h5>
                              <div class="listing">
                                <p> No effort required.</p>
                                <p>
                                  {" "}
                                  The system encourages its customers to move
                                  toward Best Practice Inventory Management, so
                                  the Inventory Management Type can always be
                                  upgraded to either Sales-Based Estimate or
                                  Actual.
                                </p>
                                <h5>Cons</h5>
                                <p>
                                  {" "}
                                  No basis for confirming whether there are any
                                  inventory variances worth following-up, which
                                  could have resulted in a cost savings
                                </p>
                              </div>
                            </article>
                          </div>
                          <div
                            onClick={() =>
                              setPostData({
                                ...postData,
                                expected_inventory_calculation: 0,
                              })
                            }
                            class="radio-cust"
                          >
                            <input
                              type="radio"
                              name="data[InventoryGeneralSetting][expected_inventory_calculation]"
                              id="InventoryGeneralSettingExpectedInventoryCalculation0"
                              value="0"
                              checked={
                                postData.expected_inventory_calculation === 0
                                  ? true
                                  : false
                              }
                            />
                            <label for="InventoryGeneralSettingExpectedInventoryCalculation0">
                              0
                            </label>{" "}
                          </div>
                        </div>
                      </li>

                      <li>
                        <div class="col-set">
                          <div class="none-sec">
                            <h4>Sales-Based Estimate</h4>
                            <article>
                              <p>
                                This will enable the system to perform an
                                Expected Inventory calculation using the latest
                                transaction data for the purposes of variance
                                analysis or to populate any Expected Inventory
                                fields in the Inventory module.
                              </p>
                              <h6>
                                <strong>
                                  Available for None and Physical Only
                                </strong>
                              </h6>
                              <h5>Pros</h5>
                              <div class="listing">
                                <p>
                                  {" "}
                                  Generates useful analytics for any variance
                                  comparisons (only with Physical Only or
                                  Perpetual and Physical Inventory Management
                                  Types).
                                </p>
                                <p>
                                  {" "}
                                  Provides transparency on the expected level of
                                  inventory for ingredients when ordering stock.
                                </p>
                                <p>
                                  {" "}
                                  The system encourages its customers to move
                                  toward Best Practice Inventory Management, so
                                  the Inventory Management Type can always be
                                  upgraded to Actual.
                                </p>
                                <h5>Cons</h5>
                                <p>
                                  {" "}
                                  Only ingredient inventory can be calculated in
                                  this model, so any recipe and menu item
                                  inventory items cannot be estimated.
                                </p>
                              </div>
                              <h5>Logic</h5>
                              <div class="listing">
                                <p>
                                  {" "}
                                  Any registered menu item transactions in the
                                  system can be converted back to used
                                  ingredients as long as the ingredient, recipe,
                                  and menu item settings are complete and
                                  up-to-date.
                                </p>
                              </div>
                            </article>
                          </div>
                          <div
                            onClick={() => {
                              if (
                                [1, 2].includes(
                                  postData.inventory_management_type
                                )
                              )
                                dispatch(
                                  actions.showNotificationWithTimeout(
                                    `${"This option is only available for 'None and Physical' Inventory Management Type"}`,
                                    "error"
                                  )
                                );
                              else
                                setPostData({
                                  ...postData,
                                  expected_inventory_calculation: 1,
                                });
                            }}
                            class="radio-cust"
                          >
                            <input
                              type="radio"
                              name="data[InventoryGeneralSetting][expected_inventory_calculation]"
                              id="InventoryGeneralSettingExpectedInventoryCalculation1"
                              value="1"
                              checked={
                                postData.expected_inventory_calculation === 1
                                  ? true
                                  : false
                              }
                            />
                            <label for="InventoryGeneralSettingExpectedInventoryCalculation1">
                              1
                            </label>{" "}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="col-set">
                          <div class="none-sec">
                            <h4>Actual</h4>
                            <article>
                              <p>
                                This will enable the best practice inventory
                                estimation functionality by allowing users to
                                have full transparency when performing supply
                                orders as well as compare the latest inventory
                                count for ingredients, recipes, and menu items
                                against a closely-tracked check-in/check-out
                                process stock level output. This is the
                                RECOMMENDED option.
                              </p>
                              <h6>
                                Only available with Perpetual and Physical
                                Inventory Management Type – Automatically
                                defaulted with the selection of Perpetual and
                                Physical
                              </h6>
                              <h5>Pros</h5>
                              <div class="listing">
                                <p>
                                  {" "}
                                  Provides maximum transparency on the expected
                                  level of inventory for ingredients, menu items
                                  and recipes when ordering stock.
                                </p>
                                <p>
                                  {" "}
                                  Allows ability to include Ingredients, Recipes
                                  and Menu Items in any variance analysis
                                  against Physical inventory counts
                                </p>
                                <h5>Cons</h5>
                                <p>
                                  {" "}
                                  High level of effort required by storage
                                  manager to track all incoming and outgoing
                                  inventory from storage areas to ensure there’s
                                  reliable “actual“ estimates available for
                                  comparison
                                </p>
                              </div>
                            </article>
                          </div>
                          <div
                            onClick={() =>
                              setPostData({
                                ...postData,
                                expected_inventory_calculation: 2,
                              })
                            }
                            class="radio-cust"
                          >
                            <input
                              type="radio"
                              name="data[InventoryGeneralSetting][expected_inventory_calculation]"
                              id="InventoryGeneralSettingExpectedInventoryCalculation2"
                              value="2"
                              checked={
                                postData.expected_inventory_calculation === 2
                                  ? true
                                  : false
                              }
                            />
                            <label for="InventoryGeneralSettingExpectedInventoryCalculation2">
                              2
                            </label>{" "}
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="row employeeSettingSec d-flex">
              <div className="col-md-12">
                <div className="shadowclass d-flex flex-wrap align-content-start inevt-step-deatil product-sheet">
                  <h4 className="event-alert w-100">Production Sheet</h4>
                  <div className="d-flex w-100 pt-0">
                    <ul class="mgt-type col-12">
                      <li>
                        <div class="col-set">
                          <div class="none-sec">
                            <h4>None</h4>
                            <article>
                              <p>
                                By selecting this option, the system will not
                                enable the ability to leverage forecasted or
                                predicted sales amounts in order to determine
                                bulk ingredient check-out needs.
                              </p>
                              <h6>
                                <strong>
                                  Available for all Inventory Management Types
                                </strong>
                              </h6>
                              <h6></h6>
                            </article>
                          </div>
                          <div
                            onClick={() =>
                              setPostData({
                                ...postData,
                                production_sheet: 0,
                              })
                            }
                            class="radio-cust"
                          >
                            <input
                              type="radio"
                              name="data[InventoryGeneralSetting][production_sheet]"
                              id="InventoryGeneralSettingProductionSheet0"
                              value="0"
                              checked={
                                postData.production_sheet === 0 ? true : false
                              }
                            />
                            <label for="InventoryGeneralSettingProductionSheet0">
                              0
                            </label>{" "}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="col-set">
                          <div class="none-sec">
                            <h4>Forecasted</h4>
                            <article>
                              <p>
                                By selecting this option, the system will enable
                                the ability to leverage forecasted sales amounts
                                and historical proportions of menu item sales in
                                order to determine bulk ingredient check-out
                                needs.
                              </p>
                              <h6>
                                <strong>
                                  Available for Perpetual and Physical Inventory
                                  Management Type only or a combination of
                                  Physical Only and Sales-Based Estimate
                                  Inventory Calculation Type
                                </strong>
                              </h6>
                            </article>
                          </div>
                          <div
                            onClick={() =>
                              setPostData({
                                ...postData,
                                production_sheet: 1,
                              })
                            }
                            class="radio-cust"
                          >
                            <input
                              type="radio"
                              name="data[InventoryGeneralSetting][production_sheet]"
                              id="InventoryGeneralSettingProductionSheet1"
                              value="1"
                              checked={
                                postData.production_sheet === 1 ? true : false
                              }
                            />
                            <label for="InventoryGeneralSettingProductionSheet1">
                              1
                            </label>{" "}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="col-set">
                          <div class="none-sec">
                            <h4>Predictive</h4>
                            <article>
                              <p>
                                By selecting this option, the system will enable
                                the ability to leverage statistical analysis of
                                historical sales amounts as well as historical
                                proportions of menu item sales in order to
                                determine bulk ingredient check-out needs.
                              </p>
                              <h6>
                                <strong></strong>
                              </h6>
                            </article>
                          </div>
                          <div
                            onClick={() => {
                              dispatch(
                                actions.showNotificationWithTimeout(
                                  `${"Not available in the initial release"}`,
                                  "error"
                                )
                              );

                              //  setPostData({
                              //       ...postData,
                              //       production_sheet: 2,
                              //     })
                            }}
                            class="radio-cust"
                          >
                            <input
                              type="radio"
                              name="data[InventoryGeneralSetting][production_sheet]"
                              id="InventoryGeneralSettingProductionSheet2"
                              value="2"
                              checked={
                                postData.production_sheet === 2 ? true : false
                              }
                            />
                            <label for="InventoryGeneralSettingProductionSheet2">
                              2
                            </label>{" "}
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {postData.production_sheet !== 0 && (
              <div className="row employeeSettingSec d-flex">
                <div className="col-md-12">
                  <div className="shadowclass d-flex flex-wrap align-content-start inevt-step-deatil product-sheet">
                    <div id="pre" class="">
                      <div class="pre-populated">
                        <div class="checkbox mt-0">
                          <input
                            type="hidden"
                            name="data[InventoryGeneralSetting][pre_populate]"
                            id="InventoryGeneralSettingPrePopulate_"
                            value="0"
                          />
                          <input
                            type="checkbox"
                            name="data[InventoryGeneralSetting][pre_populate]"
                            value="1"
                            id="InventoryGeneralSettingPrePopulate"
                            checked={
                              postData?.pre_populate === 1 ? true : false
                            }
                          />
                          <label
                            onClick={() =>
                              setPostData({
                                ...postData,
                                pre_populate:
                                  postData?.pre_populate == 1 ? 0 : 1,
                              })
                            }
                            for="InventoryGeneralSettingPrePopulate"
                          >
                            Pre-Populated Check-Out Amounts
                          </label>{" "}
                        </div>
                        <p>
                          Activates the process where the user reviews, edits
                          (if applicable), and approves the Daily Production
                          Sheet and goes on to a pre-populated, bulk ingredient
                          check-out sheet to save storage manager time.
                        </p>
                        <label>
                          Margin of Error
                          <input
                            onChange={(e) =>
                              setPostData({
                                ...postData,
                                margin_of_error: e.target.value,
                              })
                            }
                            value={postData?.margin_of_error}
                            name="data[InventoryGeneralSetting][margin_of_error]"
                            number="number"
                            class="number_format"
                            type="number"
                            id="InventoryGeneralSettingMarginOfError"
                          />
                          %
                        </label>
                        <p>
                          Automatically adds the provided margin of error to any
                          pre-populated daily quantity required.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div class="row mx-0">
          <div class="container px-0 d-flex col-12">
            <div class="btns col-4 d-flex justify-content-end py-4 col-12">
              <button
                onClick={() =>
                  dispatch(actions.postInventoryGeneralSettingsData(postData))
                }
                id=""
                type="Submit"
              >
                Save
              </button>
              <button id="cancel" type="button">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default InventoryGeneralSettings;
